"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const debounce_1 = __importDefault(require("lodash/debounce"));
const expertsSlice_1 = require("../../../../redux/slices/expertsSlice");
const core_1 = require("@material-ui/core");
const SearchIcon_1 = __importDefault(require("../../../../svgIcons/SearchIcon"));
const CloseIcon_1 = __importDefault(require("../../../../svgIcons/CloseIcon"));
const styles_1 = require("@material-ui/styles");
require("./searchbar.scss");
const useTreeStyles = {
    input: {
        backgroundColor: 'white',
        fontSize: 14
    }
};
let inited = false;
class SearchBar extends react_1.Component {
    constructor(props) {
        super(props);
        this.handleInputChange = (e) => {
            const { experts: { filter } } = this.props;
            const { value } = e.target;
            this.setState({ searchValue: value });
            this.query(Object.assign(Object.assign({}, filter), { q: value, offset: 0 }));
            this.props.handleInputChange(e.target.value !== '' ? false : true);
        };
        this.clearInput = () => {
            this.props.handleInputChange(true);
            const { experts: { filter } } = this.props;
            this.setState({ searchValue: '' });
            this.query(Object.assign(Object.assign({}, filter), { q: '', offset: 0 }));
        };
        this.cancelSearch = () => {
            this.clearInput();
            this.setState({ cancelSearchActive: false });
        };
        this.state = {
            cancelSearchActive: false,
            searchValue: '',
            type: ''
        };
        this.query = debounce_1.default(this.query, 700);
    }
    static getDerivedStateFromProps(props, state) {
        var _a, _b, _c;
        const inputVal = (_b = (_a = props === null || props === void 0 ? void 0 : props.experts) === null || _a === void 0 ? void 0 : _a.filter) === null || _b === void 0 ? void 0 : _b.q;
        const type = (_c = props === null || props === void 0 ? void 0 : props.experts) === null || _c === void 0 ? void 0 : _c.filter.type;
        if (!isEqual_1.default(type, state.type)) {
            inited = false;
            return {
                searchValue: "",
                type
            };
        }
        if (inputVal &&
            !inited &&
            !isEqual_1.default(inputVal, props.experts.filter.q)) {
            inited = true;
            return {
                searchValue: inputVal,
                type
            };
        }
        return null;
    }
    query(query) {
        const { directoryType, getExperts, getServiceExperts } = this.props;
        const requestType = directoryType === 'serviceExperts' ? getServiceExperts : getExperts;
        return requestType(query);
        this.props.handleInputChange(query);
    }
    render() {
        const { classes } = this.props;
        const { searchValue, cancelSearchActive } = this.state;
        return (react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement("div", { className: 'search-bar-box text-field-custom-mb w-100' },
                react_1.default.createElement(core_1.TextField, { fullWidth: true, size: 'medium', id: 'directory-search-field', className: 'search-field', placeholder: 'Search for services or professionals', onChange: this.handleInputChange, onFocus: () => this.setState({ cancelSearchActive: true }), value: searchValue, variant: "outlined", InputProps: {
                        classes: {
                            root: classes.input
                        },
                        startAdornment: react_1.default.createElement(SearchIcon_1.default, { className: 'v2-search-icon', style: { fontSize: '14px' } }),
                        endAdornment: react_1.default.createElement("div", null, searchValue && react_1.default.createElement(CloseIcon_1.default, { onClick: this.clearInput, className: "close-icon", style: {
                                fontSize: '8px',
                                cursor: "pointer"
                            } }))
                    } }),
                react_1.default.createElement(core_1.Hidden, { smUp: true }, cancelSearchActive &&
                    react_1.default.createElement("span", { onClick: this.cancelSearch, className: "cancel-search" }, "Cancel")))));
    }
}
const mapStateToProps = (state) => {
    const { experts } = state;
    return {
        experts
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getExperts: (data) => dispatch(expertsSlice_1.getExperts(data)),
        getServiceExperts: (data) => dispatch(expertsSlice_1.getServiceExperts(data))
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(styles_1.withStyles(useTreeStyles)(SearchBar));
